<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw auto-rw page-open-left-rw" epub:type="frontmatter dedication" id="dedication">
<h1 class="dedication-title"></h1>
<p class="dedication">For my children, Tessa, Lucy, Ruby and Amelia</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?69a0bc39